import {
  anyValidator,
  validateAlpha,
  validateAlphaNumeric,
  validateBirthDate,
  validatePhoneNumber,
  validatePropertyNumber,
  validateStreet,
  validateZipCode,
} from "../generalValidators.ts";

export const guarantorFormValidators = {
  first_name: validateAlpha,
  second_name: validateAlpha,
  first_last_name: validateAlpha,
  second_last_name: validateAlpha,
  phone: validatePhoneNumber,
  birth_date: validateBirthDate,
  country: anyValidator,
  birth_city: validateAlpha,
  occupation: validateAlpha,
  street: validateStreet,
  exterior_number: validatePropertyNumber,
  interior_number: validatePropertyNumber,
  neighborhood: validateAlphaNumeric,
  postal_code: validateZipCode,
  city: validateAlpha,
  state: anyValidator,
  birth_state: anyValidator,
  birth_country: anyValidator,
};
